<template>
  <div class="pt-4">
    <p>
      {{ $t("deleteProfileForm1") }}
    </p>
    <p>
      {{ $t("deleteProfileForm2") }}
    </p>
    <p>
      {{ $t("deleteProfileForm3") }}
    </p>

    <form action="#" @submit.prevent="deleteUser">
      <div class="form-floating mb-3">
        <input
          id="deleteAccountPassword"
          v-model="password"
          :class="passwordClass"
          class="form-control"
          :placeholder="$t('password')"
          type="password"
        />
        <label for="deleteAccountPassword">{{ $t("password") }}</label>
        <div class="invalid-feedback text-start">
          {{ $t("errorInvalidPassword") }}
        </div>
      </div>

      <button
        :disabled="buttonDisabled"
        class="btn btn-danger text-white w-100"
        type="submit"
      >
        <spinner v-if="loading" centered />
        <span v-else>{{ $t("deleteProfileFormButton") }}</span>
      </button>
    </form>

    <div v-if="error" class="alert alert-danger mt-4">
      {{ errorText }}
    </div>
  </div>
</template>

<script>
import {
  deleteUser,
  EmailAuthProvider,
  reauthenticateWithCredential,
} from "firebase/auth";
import auth from "@/firebase/auth";
import Spinner from "@/components/Spinner";
export default {
  name: "DeleteProfile",
  components: {
    Spinner,
  },
  data() {
    return {
      password: null,
      passwordClass: null,
      loading: false,
      error: false,
      errorText: null,
      showModal: true,
    };
  },
  watch: {
    password(newValue) {
      this.passwordClass = this.validatePassword(newValue)
        ? "is-valid"
        : "is-invalid";
    },
  },
  computed: {
    buttonDisabled() {
      if (this.passwordClass === null || this.passwordClass === "is-invalid") {
        return true;
      }
      return this.loading;
    },
  },
  methods: {
    deleteUser() {
      this.loading = false;
      this.error = false;
      this.errorText = null;

      const _this = this;

      if (!this.buttonDisabled) {
        this.loading = true;

        reauthenticateWithCredential(
          auth.currentUser,
          EmailAuthProvider.credential(auth.currentUser.email, this.password)
        )
          .then(() => {
            deleteUser(auth.currentUser)
              .then(() => {
                this.$router.push({ name: "account.register" });
              })
              .catch((error) => {
                _this.error = true;
                _this.errorText = _this.globalErrorText(error);
                _this.loading = false;
              });
          })
          .catch((error) => {
            _this.error = true;
            _this.errorText = _this.globalErrorText(error);
            _this.loading = false;
          });
      }
    },
    close() {
      this.password = null;
      this.passwordClass = null;
      this.loading = false;
      this.error = false;
      this.errorText = null;
    },
  },
};
</script>

<style scoped></style>
